export class Schedule {

    constructor(
        public id: string,
        public title: string,
        public subTitle: string,
        public link?: string,
        public hour?: Date,
        public hourToIndent?: number,
        public long?: string,
        public lat?: string,
        public day?: string,
        public time: number = 0,
        public monday?: boolean,
        public tuesday?: boolean,
        public wednesday?: boolean,
        public thursday?: boolean,
        public friday?: boolean,
        public saturday?: boolean,
        public sunday?: boolean,
        public mondayTime?: number,
        public tuesdayTime?: number,
        public wednesdayTime?: number,
        public thursdayTime?: number,
        public fridayTime?: number,
        public saturdayTime?: number,
        public sundayTime?: number,
        

    ) { }

}